import script from "./SecScrollProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./SecScrollProgress.vue?vue&type=script&setup=true&lang=js"

import "./SecScrollProgress.vue?vue&type=style&index=0&id=0a174904&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a174904"]])

export default __exports__